var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 11,
    fill: "#FF6467"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56623_22576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.216 12.4369C17.2789 11.33 15.243 11.2264 13.2852 12.1101V11.5H12.4062V26.5H13.2852V21.0293C15.0889 20.0832 16.9832 20.1126 18.78 21.1393C19.8576 21.7552 20.9657 22.0628 22.0742 22.0628C23.1823 22.0628 24.2908 21.7551 25.3684 21.1393L25.5898 21.0127V12.0609L24.9324 12.4369C23.063 13.5054 21.0863 13.5054 19.216 12.4369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56623_22576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlags);
export default __webpack_public_path__ + "static/media/red-flags.e3db861505ed757f5d0379091f91e404.svg";
export { ForwardRef as ReactComponent };